import React from 'react';

const sections = [
  {
    heading: '1. 개인정보 처리 목적',
    body: [
      '오잉랩(이하 “회사”)은 기업회원 가입 및 관리, 채용공고 운영, 지원자 관리, 고객 문의 대응, 서비스 보안 및 법적 의무 이행을 위해 개인정보를 처리합니다.',
    ],
  },
  {
    heading: '2. 처리하는 개인정보 항목',
    body: [
      {
        type: 'table',
        headers: ['구분', '처리 항목', '처리 목적'],
        rows: [
          [
            '기업회원 가입',
            '회사명, 담당자명, 업무용 이메일, 비밀번호',
            '회원 식별 및 계정 관리',
          ],
          [
            '기업 추가정보',
            '사업자등록번호, 소재지, 회사 웹사이트, 업종, 이용 목적, 직무 정보',
            '기업 확인 및 맞춤 서비스 제공',
          ],
          [
            '채용 서비스',
            '공고 내용, 지원자 성명·연락처·이메일·비자정보·이력서·첨부파일·링크',
            '채용공고 운영 및 지원자 관리',
          ],
          [
            '자동 수집정보',
            '접속기록, IP 주소, 기기 및 브라우저 정보, 쿠키',
            '보안, 부정 이용 방지 및 서비스 개선',
          ],
        ],
      },
    ],
  },
  {
    heading: '3. 개인정보의 처리 및 보유기간',
    body: [
      '① 기업회원 정보는 회원 탈퇴 시까지 보유하며, 관계 법령에 따른 보관 의무가 있는 경우 해당 기간 동안 분리 보관합니다.',
      '② 합격자의 지원자 정보는 기업회원이 입력한 공식 입사일부터 최대 90일까지 제공한 후 삭제합니다.',
      '③ 불합격자 및 채용 마감 시까지 합격 처리되지 않은 지원자의 정보는 해당 공고가 마감되는 즉시 삭제합니다.',
      '④ 서비스 접속기록은 통신비밀보호법 등 관계 법령에서 정한 기간 동안 보관할 수 있습니다.',
    ],
  },
  {
    heading: '4. 지원자 정보에 관한 기업회원의 역할',
    body: [
      '① 기업회원은 지원자 정보를 해당 채용 목적에만 이용해야 합니다.',
      '② 기업회원은 지원자 정보를 별도로 내려받거나 보관한 경우 서비스의 열람기간과 동일한 기준으로 안전하게 파기해야 합니다.',
      '③ 기업회원은 지원자 정보를 제3자에게 제공하거나 다른 목적으로 이용하려는 경우 개인정보 보호법에 따른 별도의 동의 또는 법적 근거를 갖추어야 합니다.',
    ],
  },
  {
    heading: '5. 개인정보의 제3자 제공',
    body: [
      '회사는 정보주체의 동의가 있거나 법령에 특별한 근거가 있는 경우를 제외하고 개인정보를 제3자에게 제공하지 않습니다.',
    ],
  },
  {
    heading: '6. 개인정보 처리업무의 위탁',
    body: [
      {
        type: 'table',
        headers: ['수탁자', '위탁 업무', '보관 위치 또는 비고'],
        rows: [
          ['Amazon Web Services', '클라우드 서버 및 파일 저장', '대한민국 서울 리전'],
          ['Google', '이메일 및 서비스 운영 지원', '서비스별 정책 적용'],
          ['Microsoft Clarity·Google Analytics', '서비스 이용 분석', '쿠키 동의 범위 내 처리'],
        ],
      },
      '회사는 위탁계약을 통해 목적 외 처리 금지, 안전성 확보조치 및 재위탁 제한 등 개인정보 보호에 필요한 사항을 관리·감독합니다.',
    ],
  },
  {
    heading: '7. 개인정보의 국외 이전',
    body: [
      '회사는 국외 서비스 제공자를 이용하는 경우 이전 국가, 이전 항목, 목적, 방법 및 보유기간을 관련 법령에 따라 고지하고 필요한 동의를 받거나 적법한 근거를 확보합니다.',
    ],
  },
  {
    heading: '8. 개인정보의 파기 절차 및 방법',
    body: [
      '① 보유기간이 종료되거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.',
      '② 전자적 파일은 복구 또는 재생할 수 없는 기술적 방법으로 삭제하고, 출력물은 분쇄 또는 소각합니다.',
      '③ 법령에 따라 보존해야 하는 정보는 별도 저장공간에 분리하여 보관하며 다른 목적으로 이용하지 않습니다.',
    ],
  },
  {
    heading: '9. 정보주체의 권리와 행사 방법',
    body: [
      '정보주체는 자신의 개인정보에 대한 열람, 정정, 삭제, 처리정지 및 동의 철회를 요청할 수 있습니다. 요청은 hello@ko-ready.com 또는 서비스 내 계정 설정을 통해 접수할 수 있으며, 회사는 본인 확인 후 관계 법령에 따라 처리합니다.',
    ],
  },
  {
    heading: '10. 개인정보의 안전성 확보조치',
    body: [
      '회사는 접근권한 최소화, 인증정보 보호, 전송 및 저장 구간 암호화, 접속기록 관리, 보안 프로그램 운영, 임직원 교육 등 개인정보 보호에 필요한 기술적·관리적 조치를 시행합니다.',
    ],
  },
  {
    heading: '11. 쿠키 및 자동 수집 장치',
    body: [
      '회사는 서비스 제공과 이용 분석을 위해 쿠키를 사용할 수 있습니다. 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나 일부 기능 이용이 제한될 수 있습니다.',
    ],
  },
  {
    heading: '12. 개인정보 보호책임자 및 문의',
    body: [
      '개인정보 보호책임자: 권하연',
      '문의: hello@ko-ready.com',
      '사업자명: 오잉랩 | 사업자등록번호: 179-45-01005',
    ],
  },
  {
    heading: '13. 개인정보처리방침의 변경',
    body: [
      '이 방침은 법령 또는 서비스 변경에 따라 개정될 수 있습니다. 중요한 변경은 시행일 30일 전, 그 밖의 변경은 시행일 7일 전부터 서비스 내 공지 또는 전자우편으로 안내합니다.',
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: '기업회원 개인정보처리방침',
  lastUpdated: '2026년 8월 14일',
  effectiveDate: '2026-08-14',
  lastUpdatedLabel: '최종 수정일',
  sections,
};
